import { NON_SECRET_OBFUSCATION_KEY_B64 } from './constants/envCrypto'

// public/index.html loads /env.js before this module runs (a plain blocking <script>,
// same as before); it now sets window.__ENV_ENC__ to a base64 XOR-obfuscated payload
// instead of a plaintext window.env object. Decoded synchronously here — this file's
// own LANDING_URL export below, plus src/api/apiService.js and others, capture env.X
// into a top-level `const` at module load time, so this cannot be async like a Web
// Crypto decrypt: it must finish before this very module's own top-level lines run.
function decodeEnv() {
  const encoded = window.__ENV_ENC__
  if (!encoded) return {}
  try {
    const keyBytes = Uint8Array.from(atob(NON_SECRET_OBFUSCATION_KEY_B64), (c) => c.charCodeAt(0))
    const dataBytes = Uint8Array.from(atob(encoded), (c) => c.charCodeAt(0))
    const outBytes = dataBytes.map((b, i) => b ^ keyBytes[i % keyBytes.length])
    return JSON.parse(new TextDecoder().decode(outBytes))
  } catch {
    return {}
  }
}

export const env = { ...process.env, ...decodeEnv() }
export const LANDING_URL = env.REACT_APP_LANDING_URL || "https://gr.korres.com/el/pages/shares";
